export default "__VITE_ASSET__Dp3GOpq7__"